import script from "./SyncBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncBtn.vue?vue&type=script&lang=ts&setup=true"

import "./SyncBtn.vue?vue&type=style&index=0&id=4c19cbfa&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c19cbfa"]])

export default __exports__